(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hat-desginer-form"] && !Shopify.designMode) return;
  try {
    const body = document.querySelector('body');

  const modelViewer = document.querySelector('model-viewer');

  const addToCartForm = document.getElementById('add-to-cart-form');
  const optionsSectionHeader = document.getElementById('options-section-header');

  const optionCategories = document.getElementById('option-categories');
  const optionCategoryButtons = optionCategories.querySelectorAll('li>button');
  const optionCategoryNames = Array.from(optionCategoryButtons).map((button) => button.dataset.optionCategoryName);

  const activeOptionCategory = document.getElementById('active-option-category');
  const activeOptionCategoryBackButtons = document
    .getElementById('active-option-category')
    .querySelectorAll('[data-option-category-name] button.back');
  const activeOptionCategoryNextButtons = document
    .getElementById('active-option-category')
    .querySelectorAll('[data-option-category-name] button.next');

  const stoneOptions = document.getElementById('stone-options');

  const embroideryNameStyleOptions = document.getElementById('embroidery-name-style-options');
  const embroideryNameTextOptions = document.getElementById('embroidery-name-text-options');
  const embroideryNameColorOptions = document.getElementById('embroidery-name-color-options');
  const embroideryNameColorPrices = document.getElementById('embroidery-name-color-prices');

  const embroideryBandVariantOptions = document.getElementById('embroidery-band-variant-options');
  const embroideryBandStyleOptions = document.getElementById('embroidery-band-style-options');
  const embroideryBandTextOptions = document.getElementById('embroidery-band-text-options');
  const embroideryBandColorOptions = document.getElementById('embroidery-band-color-options');
  const embroideryBandColorPrices = document.getElementById('embroidery-band-color-prices');

  const embroideryCrownVariantOptions = document.getElementById('embroidery-crown-variant-options');
  const embroideryCrownStyleOptions = document.getElementById('embroidery-crown-style-options');
  const embroideryCrownTextOptions = document.getElementById('embroidery-crown-text-options');
  const embroideryCrownColorOptions = document.getElementById('embroidery-crown-color-options');
  const embroideryCrownColorPrices = document.getElementById('embroidery-crown-color-prices');

  const topEmblemVariantOptions = document.getElementById('top-emblem-variant-options');
  const topEmblemSymbolCategoryOptions = document.getElementById('top-emblem-symbol-category-options');
  const topEmblemSymbolOptions = document.getElementById('top-emblem-symbol-options');
  const topEmblemColorOptions = document.getElementById('top-emblem-color-options');
  const topEmblemColorPrices = document.getElementById('top-emblem-color-prices');

  const sizeOptions = document.getElementById('size-options');

  const addOnsOptions = document.getElementById('add-ons-options');

  const submitButtonContainer = document.getElementById('submit-button-container');
  const submitButton = document.getElementById('submit-button');
  const submitButtonText = submitButton.querySelector('span');
  const totalPrice = document.getElementById('total-price');

  const saveHatButton = document.getElementById('save-hat-button');
  const saveHatPopUp = document.getElementById('save-hat-popup');

  let activeOptionCategoryName = null;
  let scrollY = null;

  // Change the option category being viewed.
  const changeOptionCategory = (optionCategoryName) => {
    const categoryOptionButton = document.querySelector(`button[data-option-category-name='${optionCategoryName}']`);

    activeOptionCategoryName = optionCategoryName;

    // Scroll to the top of the screen.
    window.scrollTo(0, 0);

    optionsSectionHeader.classList.add('hidden');
    optionCategories.classList.add('hidden');
    activeOptionCategory.classList.remove('hidden');
    activeOptionCategory.classList.add('flex');
    activeOptionCategory.querySelectorAll(`[data-option-category-name='${activeOptionCategoryName}']`).forEach((el) => {
      el.classList.remove('hidden');
      el.classList.add('flex');
    });
    submitButtonContainer.classList.add('hidden');

    // If the chosen option category is anything but the sizes (crown variants), show the checkmark.
    if (optionCategoryName !== 'crown-variant') {
      categoryOptionButton.querySelector('.fa-circle-check').parentElement.classList.remove('hidden');
      categoryOptionButton.querySelector('.fa-circle-check').parentElement.classList.add('flex');
    }

    // Position the model viewer camera to focus on the selected option category.
    setTimeout(() => {
      modelViewer.cameraTarget = '0m 30m 0m';
      switch (activeOptionCategoryName) {
        case 'upper-piping':
        case 'lower-piping':
          modelViewer.cameraOrbit = '90deg 80deg 300m';
          break;
        case 'cockade':
          modelViewer.cameraOrbit = '90deg 80deg 250m';
          break;
        case 'stone':
          modelViewer.cameraOrbit = '90deg 80deg 250m';
          break;
        case 'brim':
          modelViewer.cameraOrbit = '50deg 75deg 350m';
          break;
        case 'sweatband':
          modelViewer.cameraOrbit = '0deg 110deg 200m';
          break;
        case 'bow':
          modelViewer.cameraOrbit = '90deg 110deg 200m';
          break;
        case 'lining':
          modelViewer.cameraOrbit = '270deg 180deg 400m';
          break;
        case 'embroidery-name':
          modelViewer.cameraOrbit = '90deg 80deg 350m';
          break;
        case 'embroidery-band':
        case 'embroidery-crown':
          modelViewer.cameraOrbit = '270deg 90deg 350m';
          break;
        case 'top-emblem':
          modelViewer.cameraOrbit = '270deg 40deg 550m';
          break;
        default:
          modelViewer.cameraOrbit = '65deg 80deg 550m';
          break;
      }
    }, 0);
  };

  // Close the active option category and return to the option categories list.
  const closeOptionCategory = () => {
    activeOptionCategoryName = null;

    optionsSectionHeader.classList.remove('hidden');
    optionCategories.classList.remove('hidden');
    activeOptionCategory.classList.add('hidden');
    activeOptionCategory.classList.remove('flex');
    activeOptionCategory.querySelectorAll('[data-option-category-name]').forEach((el) => {
      el.classList.add('hidden');
      el.classList.remove('flex');
    });
    submitButtonContainer.classList.remove('hidden');
  };

  // When an option category is chosen...
  optionCategoryButtons.forEach((button) => {
    button.addEventListener('click', () => {
      scrollY = window.scrollY;
      changeOptionCategory(button.dataset.optionCategoryName);
    });
  });

  // When an option category BACK button is clicked...
  activeOptionCategoryBackButtons.forEach((button) => {
    button.addEventListener('click', () => {
      closeOptionCategory();
      window.scrollTo(0, scrollY);
    });
  });

  // When an option category NEXT button is clicked...
  activeOptionCategoryNextButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const currentOptionCategoryIndex = optionCategoryNames.indexOf(activeOptionCategoryName);

      closeOptionCategory();

      if (currentOptionCategoryIndex < optionCategoryNames.length - 1) {
        changeOptionCategory(optionCategoryNames[currentOptionCategoryIndex + 1]);
      } else {
        setTimeout(() => window.scrollTo(0, document.body.scrollHeight), 0);
      }
    });
  });

  // When an option is selected...
  addToCartForm.addEventListener('change', (event) => {
    const option = event.target.name;
    const value = event.target.value;

    const title = event.target.dataset.title || 'Ej vald';
    const emptyOption = event.target.dataset.emptyOption || 'false';

    var optionCategory;

    // Find the corresponding option category.
    switch (option) {
      case 'add-ons[]':
        optionCategory = document.querySelector(`button[data-option-category-name='add-ons']`);
        break;
      default:
        optionCategory = document.querySelector(`button[data-option-category-name='${option}']`);
        break;
    }

    if (!optionCategory) return;

    // For the option category, make sure the checkmark is visible, and then update the selected value.
    optionCategory.querySelector('.fa-circle-check').parentElement.classList.remove('hidden');
    switch (option) {
      case 'add-ons[]':
        const selectedAddOnVariants = Array.from(addOnsOptions.querySelectorAll('input:checked'));

        optionCategory.querySelector('p').textContent =
          selectedAddOnVariants.map((variant) => variant.dataset.title.trim()).join(', ') || 'Ej vald';
        break;
      default:
        optionCategory.querySelector('p').textContent = title;
        break;
    }

    switch (option) {
      case 'crown-product':
        crownProductPrice = parseFloat(event.target.dataset.price);

        // Update the size options (crown variants).
        sizeOptions.querySelectorAll('label').forEach((option) => {
          const productId = option.dataset.productId;
          if (productId === value) {
            option.classList.remove('hidden');
          } else {
            option.classList.add('hidden');
          }
        });

        // If a size is already selected, and there exists an equivalent size for the new crown product, select that size,
        // otherwise, remove the size selection.
        const selectedSize = sizeOptions.querySelector('label:has(input:checked)')?.textContent.trim();
        const equivalentSize = Array.from(sizeOptions.querySelectorAll('label'))
          .find(
            (sizeOption) => sizeOption.dataset.productId === value && sizeOption.textContent.trim() === selectedSize
          )
          ?.querySelector('input');

        if (equivalentSize) {
          equivalentSize.checked = true;
          equivalentSize.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          // If no equivalent size is found, uncheck all size options.
          sizeOptions.querySelectorAll('input:checked')?.forEach((input) => {
            input.checked = false;
          });

          // Reset the size option category, and disable the submit button.
          const sizeOptionCategory = document.querySelector(`button[data-option-category-name='crown-variant']`);
          sizeOptionCategory.querySelector('p').textContent = 'Ej vald';
          sizeOptionCategory.querySelector('.fa-circle-check').parentElement.classList.add('hidden');
          submitButton.disabled = true;
          submitButtonText.textContent = 'Välj en storlek';
          saveHatButton.classList.add('hidden');
        }

        break;
      case 'upper-piping':
        upperPipingVariantPrice = parseFloat(event.target.dataset.price);
        break;
      case 'lower-piping':
        lowerPipingVariantPrice = parseFloat(event.target.dataset.price);
        break;
      case 'cockade':
        cockadeVariantPrice = parseFloat(event.target.dataset.price);

        let switchStone = false;

        // Show/hide stone options based on the selected cockade.
        stoneOptions.querySelectorAll('label').forEach((option) => {
          const prerequisiteCockades = option.querySelector('input').dataset.prerequisiteCockades?.split(',') || null;

          if (prerequisiteCockades && !prerequisiteCockades.includes(value)) {
            option.classList.add('hidden');

            if (option.querySelector('input').checked) {
              switchStone = true;
            }
          } else {
            option.classList.remove('hidden');
          }
        });

        // If the currently selected stone option was hidden, switch to the first visible stone option.
        if (switchStone) {
          const firstVisibleOption = stoneOptions.querySelector('label:not(.hidden) input');

          if (firstVisibleOption) {
            firstVisibleOption.checked = true;
            firstVisibleOption.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        break;
      case 'stone':
        stoneVariantPrice = parseFloat(event.target.dataset.price);
        break;
      case 'brim':
        brimVariantPrice = parseFloat(event.target.dataset.price);
        break;
      case 'sweatband':
        sweatBandVariantPrice = parseFloat(event.target.dataset.price);
        break;
      case 'bow':
        bowVariantPrice = parseFloat(event.target.dataset.price);
        break;
      case 'lining':
        liningVariantPrice = parseFloat(event.target.dataset.price);
        break;
      case 'embroidery-name':
        embroideryNameVariantPrice = parseFloat(event.target.dataset.price);

        // Show the correct color price.
        embroideryNameColorPrices.querySelectorAll(`[data-variant-id]`).forEach((colorPrice) => {
          if (colorPrice.dataset.variantId === value) {
            colorPrice.classList.remove('hidden');
          } else {
            colorPrice.classList.add('hidden');
          }
        });

        if (event.target.dataset.emptyOption === 'true') {
          // If the selected embroidery name is an empty option, hide the text and color options.
          embroideryNameTextOptions.classList.add('hidden');
          embroideryNameColorOptions.classList.add('hidden');
        } else {
          // Otherwise, show the text and color options.
          embroideryNameTextOptions.classList.remove('hidden');
          embroideryNameColorOptions.classList.remove('hidden');
        }

        break;
      case 'embroidery-band':
        embroideryBandVariantPrice = parseFloat(event.target.dataset.price);

        // Show the correct color price.
        embroideryBandColorPrices.querySelectorAll(`[data-variant-id]`).forEach((colorPrice) => {
          if (colorPrice.dataset.variantId === value) {
            colorPrice.classList.remove('hidden');
          } else {
            colorPrice.classList.add('hidden');
          }
        });

        if (event.target.dataset.emptyOption === 'true') {
          // If the selected embroidery band is an empty option, hide the text and color options.
          embroideryBandTextOptions.classList.add('hidden');
          embroideryBandColorOptions.classList.add('hidden');
        } else {
          // Otherwise, show the text and color options.
          embroideryBandTextOptions.classList.remove('hidden');
          embroideryBandColorOptions.classList.remove('hidden');
        }

        break;
      case 'embroidery-crown':
        embroideryCrownVariantPrice = parseFloat(event.target.dataset.price);

        // Show the correct color price.
        embroideryCrownColorPrices.querySelectorAll(`[data-variant-id]`).forEach((colorPrice) => {
          if (colorPrice.dataset.variantId === value) {
            colorPrice.classList.remove('hidden');
          } else {
            colorPrice.classList.add('hidden');
          }
        });

        if (event.target.dataset.emptyOption === 'true') {
          // If the selected embroidery name is an empty option, hide the text and color options.
          embroideryCrownTextOptions.classList.add('hidden');
          embroideryCrownColorOptions.classList.add('hidden');
        } else {
          // Otherwise, show the text and color options.
          embroideryCrownTextOptions.classList.remove('hidden');
          embroideryCrownColorOptions.classList.remove('hidden');
        }

        break;
      case 'top-emblem':
        topEmblemVariantPrice = parseFloat(event.target.dataset.price);

        // Show the correct color price.
        topEmblemColorPrices.querySelectorAll(`[data-variant-id]`).forEach((colorPrice) => {
          if (colorPrice.dataset.variantId === value) {
            colorPrice.classList.remove('hidden');
          } else {
            colorPrice.classList.add('hidden');
          }
        });

        if (event.target.dataset.emptyOption === 'true') {
          // If the selected top emblem is an empty option, hide the symbol and color options.
          topEmblemSymbolOptions.classList.add('hidden');
          topEmblemColorOptions.classList.add('hidden');
        } else {
          // Otherwise, show the symbol and color options.
          topEmblemSymbolOptions.classList.remove('hidden');
          topEmblemColorOptions.classList.remove('hidden');
        }

        break;
      case 'crown-variant':
        // Enable the submit buttom.
        submitButton.disabled = false;
        if (!hatId) {
          submitButtonText.textContent = 'L\xe4gg i varukorgen'; // Do not use real character instead of "\xe4" here, as it BREAKS SHIT.
        }
        saveHatButton.classList.remove('hidden');
        break;
      case 'add-ons[]':
        addOnVariantsPrice = Array.from(addOnsOptions.querySelectorAll('input:checked')).reduce(
          (total, input) => total + parseFloat(input.dataset.price),
          0
        );
        break;
    }

    // Update the total price.
    totalPrice.textContent = Shopify.formatMoney(
      crownProductPrice +
        upperPipingVariantPrice +
        lowerPipingVariantPrice +
        cockadeVariantPrice +
        stoneVariantPrice +
        brimVariantPrice +
        sweatBandVariantPrice +
        bowVariantPrice +
        liningVariantPrice +
        embroideryNameVariantPrice +
        embroideryBandVariantPrice +
        embroideryCrownVariantPrice +
        topEmblemVariantPrice +
        addOnVariantsPrice
    );
  });

  // Open the save hat popup when the save hat button is clicked.
  saveHatButton.addEventListener('click', () => {
    saveHatPopUp.classList.add('flex');
    saveHatPopUp.classList.remove('hidden');
    body.classList.add('overflow-hidden');
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["model-viewer"] && !Shopify.designMode) return;
  try {
    const modelViewer = document.querySelector('model-viewer');
  const modelViewerSpinner = document.getElementById('model-viewer-spinner');

  const addToCartForm = document.getElementById('add-to-cart-form');
  const formData = new FormData(addToCartForm);

  const screenWidth = window.innerWidth;
  const touchInput = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // Initialize model-viewer with the appropriate 3D model based on screen width.
  modelViewer.src = screenWidth <= 768 ? modelMobileUrl : modelUrl;

  // If the device has touch input, decrease the orbit sensitivity for better control.
  if (touchInput) {
    modelViewer.setAttribute('orbit-sensitivity', '0.3');
  }

  // When model-viewer is loaded, if a default 3D-model state is specified, initiate the model textures accordingly, including the embroideries.
  modelViewer.addEventListener('load', () => {
    if (defaultVariantName && defaultMaterialNames) {
      updateModelTextures(defaultVariantName, defaultMaterialNames);
      updateEmbroidery(
        formData.get('embroidery-name-text1'),
        formData.get('embroidery-name-style'),
        defaultMaterialNames.filter((name) => name.includes('embroidery_firstname'))
      );
      updateEmbroidery(
        formData.get('embroidery-name-text2'),
        formData.get('embroidery-name-style'),
        defaultMaterialNames.filter((name) => name.includes('embroidery_lastname'))
      );
      updateEmbroidery(
        formData.get('embroidery-band-text'),
        formData.get('embroidery-band-style'),
        defaultMaterialNames.filter((name) => name.includes('embroidery_band'))
      );
      updateEmbroidery(
        formData.get('embroidery-crown-text'),
        formData.get('embroidery-crown-style'),
        defaultMaterialNames.filter((name) => name.includes('embroidery_crown'))
      );
    }
    setTimeout(() => {
      modelViewer.classList.remove('invisible');
      modelViewerSpinner.classList.add('hidden');
    }, 100);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["school-selector-dropdown"] && !Shopify.designMode) return;
  try {
    // Fetch all schools from the paginated school JSON page.
  const fetchAllSchools = async () => {
    const schools = [];

    let url = schoolJsonPage;

    const fetchSchools = async (url) => {
      const response = await fetch(url);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const schools = Array.from(doc.getElementById('school-loop')?.children || []);
      const nextUrl = doc.getElementById('school-pagination-next')?.getAttribute('href');

      return { schools, nextUrl };
    };

    while (url) {
      const result = await fetchSchools(url);
      schools.push(...result.schools);
      url = result.nextUrl;
    }

    return schools;
  };

  document.addEventListener('DOMContentLoaded', async () => {
    const container = document.getElementById('school-selector-container');
    const searchInput = document.getElementById('school-selector-search-input');
    const dropdown = document.getElementById('school-selector-dropdown');
    const notFoundCheckbox = document.getElementById('school-selector-not-found-checkbox');

    if (!container || !searchInput || !dropdown) return;

    const hasExactMatch = (value) => {
      return schoolList.some((school) => school.name.toLowerCase() === value.toLowerCase().trim());
    };

    const showError = (show) => {
      if (show) {
        searchInput.classList.add('error');
      } else {
        searchInput.classList.remove('error');
      }
    };

    const onTextFieldChange = () => {
      if (hasExactMatch(searchInput.value)) {
        showError(false);
        sendSelectionEvent(true);
      } else {
        sendSelectionEvent(false);
      }
    };

    // Send a custom event when a school is selected, or typed exactly.
    const sendSelectionEvent = (hasSelection) => {
      const school = !hasSelection
        ? null
        : schoolList.find((s) => s.name.toLowerCase() === searchInput.value.toLowerCase().trim());

      const event = new CustomEvent('schoolSelected', {
        detail: { ...school, notFound: notFoundCheckbox?.checked || false },
      });

      container.dispatchEvent(event);
    };

    // Show dropdown on input focus
    searchInput.addEventListener('focus', () => {
      dropdown.classList.remove('hidden');
      searchInput.select();
    });

    // Hide dropdown when clicking outside of the component
    document.addEventListener('click', (e) => {
      if (!container.contains(e.target)) {
        dropdown.classList.add('hidden');
      }
    });

    notFoundCheckbox?.addEventListener('change', function () {
      if (this.checked) {
        searchInput.value = '';
        searchInput.disabled = true;
        dropdown.classList.add('hidden');
      } else {
        searchInput.disabled = false;
      }
      onTextFieldChange();
    });

    // Validate on blur (when user clicks away)
    searchInput.addEventListener('blur', () => {
      // Use a short timeout to allow click event to register first
      setTimeout(() => {
        if (notFoundCheckbox?.checked || searchInput.value === '') {
          showError(false);
          return;
        }

        if (!hasExactMatch(searchInput.value)) {
          showError(true);
        } else {
          showError(false);
        }
      }, 150); // 150ms delay
    });

    const schools = await fetchAllSchools();
    const schoolList = schools
      .map((school) => ({
        name: school.dataset.name,
        discountIds: school.dataset.discountIds,
        garpCustomer: school.dataset.garpCustomer,
        schoolDelivery: school.dataset.schoolDelivery,
      }))
      .sort((a, b) => a.name.localeCompare(b.name, 'sv'));

    for (const school of schoolList) {
      const li = document.createElement('li');
      li.textContent = school.name;
      li.classList.add('cursor-pointer', 'hover:text-onSurface');
      dropdown.appendChild(li);
    }

    // Remove the spinner.
    dropdown.children[0].remove();

    const emptyOption = document.createElement('li');
    emptyOption.classList.add('pointer-events-none', 'group-has-[li:not(:last-child):not(.hidden)]:hidden');
    emptyOption.textContent = 'Inga resultat';
    dropdown.appendChild(emptyOption);

    const options = dropdown.querySelectorAll('li:not(:last-child)');

    // Handle clicks on dropdown options
    for (const option of options) {
      option.addEventListener('click', function (e) {
        e.preventDefault();
        searchInput.value = this.innerText;
        dropdown.classList.add('hidden');

        onTextFieldChange();
      });
    }

    searchInput.addEventListener('keyup', () => {
      const filter = searchInput.value.toUpperCase();
      for (let i = 0; i < options.length; i++) {
        const txtValue = options[i].textContent || options[i].innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          options[i].classList.remove('hidden');
        } else {
          options[i].classList.add('hidden');
        }
      }
      onTextFieldChange();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
